import { render, staticRenderFns } from "./SidebarNew.vue?vue&type=template&id=018610dc&scoped=true&"
import script from "./SidebarNew.vue?vue&type=script&setup=true&lang=js&"
export * from "./SidebarNew.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SidebarNew.vue?vue&type=style&index=0&id=018610dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018610dc",
  null
  
)

export default component.exports